@if (isOffline()) {
  <div class="wrapper">
    <div class="toast">
      <div class="content">
        <app-src-icon name="wifi_off"></app-src-icon>
        <div class="details">
          <span>You are offline.</span>
          <div>Connect to the Internet to use Metabox.</div>
        </div>
      </div>
    </div>
  </div>
}
